require('login/bootstrap');
const cookie = require('cookie');
// eslint-disable-next-line import/no-unresolved
const globals = require('client_cw_globals/index');
const { initDDrum, startLogging } = require('reduxApp/Utils/ddRumUtils');

// DataDog-rum init
if (globals.ddRumApplicationId && globals.ddRumClientToken) {
  initDDrum(`classwallet@${window.appVersion}`);
}

$(() => {
  if (top != self) {
    $('body').html('<p>This application can not be loaded in an iFrame</p>');
    return false;
  }

  const Backbone = require('backbone');
  const Login = require('login');
  const LoginLayout = require('login/layouts/login_layout');

  const cookies = cookie.parse(document.cookie);

  const login = new Login();
  const loginLayout = new LoginLayout({
    reCaptchaKey: globals.reCaptchaSiteKey,
    isCaptchaDisabled: globals.disableLoginCaptcha === 'true' || 'disableLoginCaptcha' in cookies,
  });

  login.addRegions({
    LoginRegion: '#login-region',
  });

  login.LoginRegion.show(loginLayout);
  login.start();

  Backbone.history.start();

  $.ajaxSetup({
    xhrFields: {
      withCredentials: true,
    },
    crossDomain: true,
  });

  startLogging();
});
